import gql from "graphql-tag";

export const IconDetailPartsFragmentDoc = gql`
    fragment IconDetailParts on IconType {
        id
        title
        creator {
            name
            id
            username
            avatarUrl
        }
        thumbnail
        slugWithId
    }
`;

export const PrepaidBalancePartsFragmentDoc = gql`
    fragment PrepaidBalanceParts on CurrentUserType {
        hasPrepaidBalance
        totalPrepaidBalanceAvailableCents
    }
`;
